// Shared color constants for the admin panel, kept in one place so
// TM/No-TM group encoding and severity colors stay consistent across pages.

export const TM_COLOR = '#1976d2';
export const NO_TM_COLOR = '#ed6c02';

// Re-exported so existing admin imports of SEVERITY_STYLES from here keep working;
// the canonical definition lives in components/shared/severityStyles.js.
export { SEVERITY_STYLES } from '../shared/severityStyles';
